<script lang="ts">
  import { invalidate } from '$app/navigation';
  import { page, updated } from '$app/stores';
  import { onMount } from 'svelte';
  import '../app.postcss';
  import 'iconify-icon';
  import LoadingBar from '$lib/components/loading-bar';

  export let data;

  $: ({ supabase, session } = data);

  onMount(() => {
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange((event, _session) => {
      if (_session?.expires_at !== session?.expires_at) {
        invalidate('supabase:auth');
      }
    });

    return () => subscription.unsubscribe();
  });
</script>

<LoadingBar class="text-purple-500" />
<div
  class=""
  data-sveltekit-reload={$updated ? '' : 'off'}
  data-sveltekit-preload-code="hover"
>
  <slot />
</div>
